module.exports = __webpack_public_path__ + "img/quick_01.26a6d307.png";